export default "__VITE_ASSET__Dea1m7JP__"